import { Button, IconButton } from "@mui/material";
import { useEffect } from "react";
import { FiPlus, FiTrash2 } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import ListView from "../components/ListView/ListView";
import Window from "../components/Window/Window";
import { userColumns } from "../constants/dataGridColumns";
import useApiRequest from "../hooks/useApiRequest";

const Users = () => {
    const navigate = useNavigate();
    const { data, loading, list, remove } = useApiRequest("/users");

    useEffect(() => {
        list();
        // eslint-disable-next-line
    }, []);

    const handleRowClick = (user) => {
        if (!user?.id) {
            console.error("Error: No se encuentra al usuario");
            return;
        }
        navigate(`/user-form`, { state: { id: user?.id } });
    };

    const handleRowDelete = async (id) => {
        const confirmDelete = window.confirm(
            "¿Estás seguro de que deseas eliminar este usuario?"
        );
        if (confirmDelete) {
            try {
                await remove(id);
                list();
            } catch (error) {
                console.error("Error al eliminar el registro:", error);
            }
        }
    };

    const columns = [
        ...userColumns,
        {
            field: "actions",
            headerName: "Actions",
            width: 150,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                return (
                    <IconButton
                        aria-label="delete"
                        color="secondary"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleRowDelete(params.row.id);
                        }}
                    >
                        <FiTrash2 />
                    </IconButton>
                );
            },
        },
    ];
    return (
        <Window title={"Usuarios"}>
            {loading ? (
                <div style={{ textAlign: "center", padding: "20px" }}>
                    <span style={{ fontSize: "18px", color: "#666" }}>
                        Cargando...
                    </span>
                </div>
            ) : (
                <ListView
                    columns={columns}
                    data={data}
                    onRowClick={handleRowClick}
                    TopRigthButtons={
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<FiPlus />}
                            onClick={() => {
                                navigate(`/user-form`);
                            }}
                        >
                            Nuevo usuario
                        </Button>
                    }
                />
            )}
        </Window>
    );
};

export default Users;
